import createSvgIcon from '../Utils/CreateSvgIcon';

export const List = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M7 5.5L21 5.5V3.5L7 3.5V5.5ZM7 10.5L21 10.5V8.5L7 8.5L7 10.5ZM21 15.5L7 15.5V13.5L21 13.5L21 15.5ZM7 20.5L21 20.5V18.5L7 18.5L7 20.5ZM5 10.5H3L3 8.5H5L5 10.5ZM3 5.5H5V3.5L3 3.5L3 5.5ZM5 15.5H3V13.5H5V15.5ZM3 20.5H5L5 18.5H3L3 20.5Z"
    fillRule="evenodd"
  />,
  'List',
);
